/**
 * 存储localStorage
 */
const setStore = (name, content) => {
  if (!name) return;
  if (typeof content !== "string") {
    content = JSON.stringify(content);
  }
  window.localStorage.setItem(name, content);
};

/**
 * 获取localStorage
 */
const getStore = (name) => {
  if (!name) return;
  return window.localStorage.getItem(name);
};

/**
 * 删除localStorage
 */
const removeStore = (name) => {
  if (!name) return;
  window.localStorage.removeItem(name);
};
// 删除所有
const clearStore = () => {
  window.localStorage.clear();
};

const getMonDate = () => {
  let d = new Date();
  let day = d.getDay();
  let date = d.getDate();
  if (day === 1) {
    return d;
  }
  if (day === 0) {
    d.setDate(date - 6);
  } else {
    d.setDate(date - day + 1);
  }
  return d;
};

const timeToSec = (time) => {
  var s = "";
  var hour = time.split(":")[0];
  var min = time.split(":")[1];
  var sec = time.split(":")[2];
  s = Number(hour * 3600) + Number(min * 60) + Number(sec);
  return s;
};
// js秒数 格式化为 分秒
function formatSeconds(time) {
  let timeStr = "";
  let stringFormat = (i) => {
    return i < 10 ? `0${i}` : `${i}`;
  };
  let minuteTime = 0;
  let secondTime = 0;
  let hourTime = 0;
  if (time < 60) {
    timeStr = `00:${stringFormat(time)}`;
  } else if (time >= 60 && time < 3600) {
    minuteTime = parseInt(time / 60);
    secondTime = parseInt(time % 60);
    timeStr = `${stringFormat(minuteTime)}:${stringFormat(secondTime)}`;
  } else if (time >= 3600) {
    let _t = parseInt(time % 3600);
    hourTime = parseInt(time / 3600);
    minuteTime = parseInt(_t / 60);
    secondTime = parseInt(_t % 60);
    timeStr = `${stringFormat(hourTime)}:${stringFormat(
      minuteTime
    )}:${stringFormat(secondTime)}`;
  }
  return timeStr;
}
const formatDate = (value) => {
  var theTime = parseInt(value); // 秒
  var middle = 0; // 分
  var hour = 0; // 小时

  if (theTime > 60) {
    middle = parseInt(theTime / 60);
    theTime = parseInt(theTime % 60);
    if (middle > 60) {
      hour = parseInt(middle / 60);
      middle = parseInt(middle % 60);
    }
  }
  var result = "" + parseInt(theTime) + "秒";
  if (middle > 0) {
    result = "" + parseInt(middle) + "分" + result;
  }
  if (hour > 0) {
    result = "" + parseInt(hour) + "小时" + result;
  }
  return result;
};
/**
 * [min,max] 的随机数，公式如下：
 * @param {*} min
 * @param {*} max
 */
const random = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1) + min);
};

export {
  setStore,
  getStore,
  removeStore,
  clearStore,
  getMonDate,
  random,
  formatSeconds,
  timeToSec,
  formatDate,
};
